module.exports = React.addons.CSSTransitionGroup;


//////////////////
// WEBPACK FOOTER
// external "React.addons.CSSTransitionGroup"
// module id = 24
// module chunks = 0